<template>
    <div>
        <h1>admin home</h1>
        <router-link :to="'/admin/seasons'">Manage Seasons</router-link>
    </div>
</template>

<script>
  export default {
    name: "AdminHome",
    data() {
        return {}
    },
    mounted() {
    }
  }
</script>

<style scoped>

</style>
